import axios from "axios";
import env from "../variables/EndpointEnvironment";

const GlobalSearchingAPI = (props) => {
  return axios.get(
    `${env.HOST_GLOBAL}/global_search${props}`
  );
};
export default GlobalSearchingAPI;